<template>
  <div class="ch-container">
    <div class="logo-bar">
      <el-row>
        <el-col :span="12">
          <logo-view />
        </el-col>
        <el-col :span="12">
          <div style=" text-align: right;">
            <el-button @click="onLogin" type="text">登录</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import logoView from "../../components/logo";
export default {
  components: {
    logoView,
  },
  methods:{
    onLogin(){
      this.$router.push("/login")
    }
  }
};
</script>

<style lang="less" scoped>
.logo-bar {
  padding: 20px 0;
}
</style>